import * as React from "react";
import ForgotPassword from "../../screens/ForgotPassword/Forgotpassword";
import { connect } from "react-redux";
import { forgotpassword, CheckOtp,resendOtp,pswdChange,setInitialScreen } from "./action";
class FrgtPswdContainer extends React.Component<Props, State> {
  render() {
    return (
      <ForgotPassword
        forgotpassword={this.props.forgotpassword}
        CheckOtp={this.props.CheckOtp}
        resendOtp={this.props.resendOtp}
        pswdChange={this.props.pswdChange}
        screen={this.props.screen}
        setInitialScreen={this.props.setInitialScreen}
      ></ForgotPassword>
    );
  }
}

function bindAction(dispatch) {
  return {
    forgotpassword: (value) => {
      dispatch(forgotpassword(value));
    },
    CheckOtp: (otpvalue) => {
    
      dispatch(CheckOtp(otpvalue));
    },
    setInitialScreen: () => {
      dispatch(setInitialScreen());
    },
    resendOtp: () => {
      dispatch(resendOtp());
    },
    pswdChange: resetValue => {
     
      dispatch(pswdChange(resetValue))
    },
  };
}

function mapStateToProps(state) {
  return {
    screen: state.forgotReducer.screen,
    forgtMobNo: state.forgotReducer.forgtMobNo,
  };
}

export default connect(mapStateToProps, bindAction)(FrgtPswdContainer);
